import { BookWithConfidence } from './book_with_confidence';

export default BookWithConfidence;
